import copyToClipboard from '../common/copyToClipboard';

$(function () {
    $(document).on('click', '[data-copy-to-clipboard]', function () {
        let $this = $(this);
        const value = $this.attr('data-copy-to-clipboard');
        $this.addClass('success-copy');
        copyToClipboard(value);
    });
});
